export enum NavigationEndpoint {
  recordings = 'recordings',
  clips = 'clips',
  social = 'social',
  blog = 'blog',
  email = 'email',
  takeaways = 'takeaways',
  custom = 'custom'
}
